import React from 'react';
import { getColumnsForTable } from '../../../utils/getColumnsForTable';
import ClientCardInfo from './ClientCardInfo';
import { Icons } from '../../../components/base/BootstrapComponents';
import { addClientColumns, defaultColumns } from '../constants';

export default function ClientCard(props) {
  const { selectedItem, setIsPopUp } = props;
  const basicKeys = ['status', 'id', 'parking_zone', 'client', 'lpn', 'description', 'type', 'expiry_at', 'issue_at'];
  return (
    <div className="client-card">
      <span className="client-card-title">Основная информация</span>
      <div className="client-card-box">
        <div className="client-card-basic-information">
          <div className="client-card-basic-information-box">
            {getColumnsForTable([...defaultColumns, ...addClientColumns], basicKeys).map((column, index) => (
              <div className="client-card-basic-information-box-item" key={index}>
                <div className="client-card-basic-information-box-item-title">{column.text}</div>
                <div className="client-card-basic-information-box-item-content">
                  {column.formatter ? column.formatter(selectedItem[column.dataField]) : selectedItem[column.dataField]}
                  {column.dataField === 'lpn' ? selectedItem.lpn : null}
                </div>
              </div>
            ))}
          </div>
        </div>
        <ClientCardInfo selectedItem={selectedItem} />
      </div>
    </div>
  );
}
